import { useEffect } from 'react';
import useSessionTimeout from '../../hooks/common/useSessionTimeout';

/**
 * SessionTimeout Component
 * 
 * Handles automatic session timeout after 5 minutes of inactivity.
 * Shows a warning notification 10 seconds before the session expires.
 * 
 * This component doesn't render anything - it just sets up the session timeout logic.
 */
const SessionTimeout = () => {
  useSessionTimeout();

  // This component doesn't render anything
  return null;
};

export default SessionTimeout;
